export function formatRole(role) {
  if (!role) return '';
  return role.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
}

export function countAll(node) {
  var c = 0;
  var ch = node.children || [];
  for (var i = 0; i < ch.length; i++) { c += 1 + countAll(ch[i]); }
  return c;
}

export function getRoleStyle(role) {
  switch(role) {
    case 'admin': return { border: 'border-red-400', badge: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300' };
    case 'company_sales_head': return { border: 'border-purple-400', badge: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300' };
    case 'country_sales_head': return { border: 'border-blue-400', badge: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' };
    case 'regional_sales_head': return { border: 'border-teal-400', badge: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300' };
    case 'manager': return { border: 'border-amber-400', badge: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' };
    case 'team_leader': return { border: 'border-green-400', badge: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300' };
    case 'solutions_architect': return { border: 'border-indigo-400', badge: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300' };
    case 'pre_sales_engineer': return { border: 'border-cyan-400', badge: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300' };
    default: return { border: 'border-slate-300 dark:border-slate-600', badge: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-400' };
  }
}

// Flatten tree into a list of {node, depth} for iterative rendering
export function flattenTree(roots, expandedSet) {
  var result = [];
  function walk(nodes, depth) {
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      result.push({ node: n, depth: depth });
      if (expandedSet.has(n.id) && n.children && n.children.length > 0) {
        walk(n.children, depth + 1);
      }
    }
  }
  walk(roots, 0);
  return result;
}
